(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.controller('deliveryScoreTrendCtrl', deliveryScoreTrendCtrl);

	deliveryScoreTrendCtrl.$inject = ['$rootScope', '$scope', '$timeout',
		'dashboardFilterInitializationService', 'leanFilterService', 'deliveryScoreTrendService', 'pageTimingService'];

	function deliveryScoreTrendCtrl($rootScope, $scope, $timeout,
			dashboardFilterInitializationService, leanFilterService, deliveryScoreTrendService, pageTimingService) {
		var reportConfig = {};

		$scope.emptyHeader = 'We couldn\'t find any results.';
		$scope.emptySuggestion = '';
		$scope.emptyLinkText = '';

		function getSupplierPerformanceBuckets(data, noOfMonths) {
			var buckets = {
				'delPerfMonthBucket': [],
				'delPerf3MonthRollingBucket': [],
				'delPerfMonthBucketRnk': []
			};
			for (var i = 0; i < noOfMonths; i++) {
				buckets['delPerfMonthBucket'].push(data['delPerfMonthBucket' + (i + 1)] || 'null');
				buckets['delPerf3MonthRollingBucket'].push(data['delPerf3MonthRollingBucket' + (i + 1)] || 'null');
				buckets['delPerfMonthBucketRnk'].push(data['delPerfMonthBucket' + (i + 1) + 'Rnk'] || 'null');
			}
			return buckets;
		}

		function init() {
			$scope.filterService = dashboardFilterInitializationService;
			$scope.leanFilterService = leanFilterService;
			$scope.initialLoad = true;
			$scope.loading = true;
			$scope.slideshowView = $rootScope.slideshowView;
			$scope.config.title = 'Delivery Score Trend';

			updateEventBind($scope, [
				'sideBarUpdate', 'inventoryFilterChanged', 'slideshowViewChanged'
			]);

			reportConfig.getChart = function () {
				var canLoad = true;
				for (var key in $scope.filterService.updating) {
					if ($scope.filterService.updating[key]) {
						canLoad = false;
						break;
					}
				}
				if (canLoad) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
					deliveryScoreTrendService.getChartData($scope.leanFilterService).then(function (data) {
						$scope.loading = false;
						$scope.initialLoad = false;

						if (!data) {
							$scope.empty = true;
						} else {
							var buckets = getSupplierPerformanceBuckets(data, 12);
							$scope.monthlyValues = _.reverse(buckets['delPerfMonthBucket']);
							$scope.threeMonthAvgValues = _.reverse(buckets['delPerf3MonthRollingBucket']);
							$scope.monthlyRank = _.reverse(buckets['delPerfMonthBucketRnk']);
							$scope.noPerformanceData = _.reject($scope.monthlyValues, _.isNumber).length == 12 &&
								_.reject($scope.threeMonthAvgValues, _.isNumber).length == 12;
							$scope.$broadcast('deliveryScoreTrendChartReady', null);
						}

						$rootScope.title = 'LeanDNA Dashboard - Delivery Score Trend';
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					});
				} else {
					$timeout(function () {
						reportConfig.getChart();
					}, 10);
				}
			};

			reportConfig.getChart();
		}

		init();
	}
})();
